(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _slider = require('./slider');

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./slider":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($) {
  if ($ !== undefined && $('.parceiros-m1__swiper').length) {
    $('.parceiros-m1__swiper').map(function (index, value) {
      var swiperItem = $(value);

      (function (swiperItem) {
        new Swiper(swiperItem, {
          pagination: swiperItem.data('pagination'),
          paginationClickable: true,
          slidesPerColumn: 2,
          slidesPerColumnFill: 'row',
          slidesPerView: swiperItem.data('per-view'),
          slidesPerGroup: swiperItem.data('per-view'),
          spaceBetween: swiperItem.data('space-between'),
          autoplay: swiperItem.data('autoplay'),
          loop: swiperItem.data('loop'),
          breakpoints: {
            // when window width is <= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
              slidesPerGroup: 2
            },
            // when window width is <= 640px
            640: {
              slidesPerView: 3,
              spaceBetween: 30,
              slidesPerGroup: 3
            },
            // when window width is <= 992px
            992: {
              slidesPerView: 4,
              spaceBetween: 30,
              slidesPerGroup: 4
            }
          }
        });
      })(swiperItem);
    });
  }
}(jQuery);

},{}]},{},[1]);
